exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-client[data-v-5a41af4d] {\n  padding-top: 12px;\n  height: 40px;\n}", ""]);

// exports
